import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-info-row',
  templateUrl: './info-row.component.html',
  styleUrls: ['./info-row.component.scss'],
  standalone: false
})
export class InfoRowComponent {
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() disabled: boolean = false;

  @Output() rowClick = new EventEmitter<void>();

  onClick(): void {
    if (!this.disabled) {
      this.rowClick.emit();
    }
  }
}
